export default __webpack_public_path__ + "static/media/carnew.b719e670.jpg";